import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import * as authActions from '../../../context/auth/authActions';
import classes from './Logout.module.css';

const Logout = props => {
	const { onLogout } = props;

	const submitHandler = event => {
		event.preventDefault();
		onLogout();
	};

	const redirect = () => {
		return <Redirect to="/auth" />;
	};

	return (
		<div className={classes.container}>
			<form onSubmit={submitHandler}>
				<input className={classes.logOutButton} type="submit" value="Log Out" onClick={redirect} />
			</form>
		</div>
	);
};

const mapDispatchToProps = dispatch => {
	return {
		onLogout: () => dispatch(authActions.logout()),
	};
};

export default connect(null, mapDispatchToProps)(Logout);
